// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_25beS7Z1dwf7biJC5cvRp8","alert":"_2szYugop_iqirVTBBWWH89","container":"_610rOrUrvXimqH-TNxYm-","disableClick":"_2wZE8MD6I41G4eSgAyZES-"};